import React from 'react';
import { resolve } from 'library/helpers/path-resolver';
import CloneableInputGroup from 'library/components/cloneable-input-group';
import { InputEvent as SyntheticEvent } from 'library/helpers/synthetic-events';
import Toggle from 'library/components/form-elements/toggle';
import Tag from 'library/components/tag';
import StateSelect from 'library/components/form-elements/state';
import CountrySelect from 'library/components/form-elements/country';

const CurrentYear = (new Date()).getFullYear();

const ResumeFields = ({ className='', data, onChange, baseKey = '', index, active=false }) => {
    const Years = [...Array(100).keys()].map(n=><option key={CurrentYear - n} value={CurrentYear - n}>{CurrentYear - n}</option>);

    const remove = () => {
        onChange(new SyntheticEvent({
            name: baseKey,
            value: undefined,
            type: 'object'
        }));
    }

    const handleChangeDate = (e) => {
        const { name, value } = e.target;
        const [ key, type ] = name.split('_');

        let [ year, month, day='01' ] = (resolve(data, `date_range.${key}`, '--1', '.') || '').split('-').map(v=>v||'');

        if (type === 'month') {
            month = value;
        } else if (type === 'year') {
            year = value;
        }

        onChange(new SyntheticEvent({
            name: `${baseKey}.date_range.${key}`,
            value: `${year}-${month}-01`
        }))
    }

    const handleCurrentJob = (e) => {
        onChange(new SyntheticEvent({
            name: `${baseKey}.date_range.end`,
            value: undefined
        }))

        onChange(e);
    }

    let [start_year='',start_month=''] = (resolve(data, 'date_range.start', '--1', '.') || '').split('-').map(v=>v||'');

    let [finish_year='',finish_month=''] = (resolve(data, 'date_range.finish', '--1', '.') || '').split('-').map(v=>v||'');

    return (
        <div className={className}>
            <label>
                Job Title
                <input placeholder="Job Title" type="text" onChange={onChange} value={data.title || ''} name={`${baseKey}.title`} disabled={!active} required={active} />
            </label>
            <label>
                Company
                <input placeholder="Company" type="text" onChange={onChange} value={data.company || ''} name={`${baseKey}.company`} disabled={!active} required={active} />
            </label>
            <label>
                City
                <input placeholder="City" type="text" onChange={onChange} value={data.city || ''} name={`${baseKey}.city`} disabled={!active} required={active} />
            </label>
            <label>
                Country
                <CountrySelect name={`${baseKey}.country`} onChange={onChange} value={resolve(data, 'country', '')} disabled={!active} required={active} />
            </label>
            <label>
                State
                <StateSelect name={`${baseKey}.state`} onChange={onChange} value={resolve(data, 'state', '')} disabled={!active||resolve(data, 'country', '')!=='United States'} required={active||resolve(data, 'country', '')==='United States'} />
            </label>
            <label>
                Time Period
                <div className="select-group">
                    <div className="select-group">
                        <select onChange={handleChangeDate} value={start_month} name={`start_month`} disabled={!active} required={active}>
                            <option value="">Month</option>
                            <option value="01">January (01)</option>
                            <option value="02">February (02)</option>
                            <option value="03">March (03)</option>
                            <option value="04">April (04)</option>
                            <option value="05">May (05)</option>
                            <option value="06">June (06)</option>
                            <option value="07">July (07)</option>
                            <option value="08">August (08)</option>
                            <option value="09">September (09)</option>
                            <option value="10">October (10)</option>
                            <option value="11">November (11)</option>
                            <option value="12">December (12)</option>
                        </select>
                        <select onChange={handleChangeDate} value={start_year} name={`start_year`} disabled={!active} required={active}>
                            <option value="">Year</option>
                            { Years }
                        </select>
                    </div>
                    <span>TO</span>
                    <div disabled={data.current} className="select-group">
                        <select onChange={handleChangeDate} value={finish_month} name={`finish_month`} disabled={!active || data.is_current} required={!data.is_current && active}>
                            <option value="">Month</option>
                            <option value="01">January (01)</option>
                            <option value="02">February (02)</option>
                            <option value="03">March (03)</option>
                            <option value="04">April (04)</option>
                            <option value="05">May (05)</option>
                            <option value="06">June (06)</option>
                            <option value="07">July (07)</option>
                            <option value="08">August (08)</option>
                            <option value="09">September (09)</option>
                            <option value="10">October (10)</option>
                            <option value="11">November (11)</option>
                            <option value="12">December (12)</option>
                        </select>
                        <select onChange={handleChangeDate} value={finish_year} name={`finish_year`} disabled={!active || data.is_current} required={!data.is_current && active}>
                            <option value="">Year</option>
                            { Years }
                        </select>
                    </div>
                </div>
                <div>Current Job? <input disabled={!active} type="checkbox" name={`${baseKey}.is_current`} checked={data.is_current || false} onChange={handleCurrentJob} /></div>
            </label>
            <label>
                Description
                <textarea placeholder="Job Description" value={data.description || ''} onChange={onChange} name={`${baseKey}.description`} disabled={!active} required={active} />
            </label>
            <div className="resume-builder-fields-controls">
                <span className="a" onClick={() => remove()}>remove</span>
            </div>
        </div>
    )
}

const WorkExperience = ({ data, handleChange }) => {
    const hasWorkHistory = resolve(data, 'has_work_histories', false, '.');

    const onChange = () => {
        handleChange(new SyntheticEvent({
            name: 'has_work_histories',
            value: !hasWorkHistory
        }));
    }

    const fieldsClass = [
        "resume-builder-fields",
        !hasWorkHistory ? 'resume-builder-fields-disabled' : null
    ].filter(c=>c).join(' ')

    return (
        <section className={!hasWorkHistory ? 'resume-builder-multi-disabled' : ''}>
            <h1><Toggle name="has_work_histories" checked={hasWorkHistory} onChange={onChange} /> Experience <Tag className="tag-auxilary-4">Suggested for Resume Creation</Tag></h1>
            <p>
              Experience includes work history, internships, apprenticeships, volunteering, and extracurricular activities. We’ll use your past experience to create your job-specific skills profile to identify transferable skills that map to many industries.
            </p>
            <CloneableInputGroup disabled={!hasWorkHistory} onChange={handleChange} values={data} dataKey="work_histories" className="resume-builder-multi">
                <ResumeFields className={fieldsClass} active={hasWorkHistory} onChange={handleChange} />
            </CloneableInputGroup>
        </section>
    )
}

export default WorkExperience;
